export default '2.1.3';



// WEBPACK FOOTER //
// ./src/lib/version.js